<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <i class="fa fa-align-justify"></i> News Items
                  <button type="button" class="btn btn-outline-primary pull-right" @click="addNews"><i class="fa fa-plus"></i>&nbsp; Add News</button>
              </div>
              <div class="card-block">
                <table class="table table-bordered table-striped table-sm">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Body</th>
                      <th>Link</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th class="text-center">Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(item, index) in newsList">
                      <tr>
                        <td>{{item.title}}</td>
                        <td>{{item.body}}</td>
                        <td>{{item.link}}</td>
                        <td>{{formatDate(item.startDate)}}</td>
                        <td>{{formatDate(item.endDate)}}</td>
                        <td class="text-center"><i class="fa fa-trash" v-if="!item.isDeleted" @click="deleteNews(index,false)"></i></td>
                      </tr>
                    </template>
                  </tbody>
                </table>
                <nav>
                  <ul class="pagination">
                    <li class="page-item"><a class="page-link" href="#">Prev</a></li>
                    <li class="page-item active">
                      <a class="page-link" href="#">1</a>
                    </li>
                    <li class="page-item"><a class="page-link" href="#">2</a></li>
                    <li class="page-item"><a class="page-link" href="#">3</a></li>
                    <li class="page-item"><a class="page-link" href="#">4</a></li>
                    <li class="page-item"><a class="page-link" href="#">Next</a></li>
                  </ul>
                </nav>
              </div>
            </div>
          </div><!--/.col-->
        </div><!--/.row-->
      </div><!--animated-fadein -->
        <b-modal title="Add New Item" large v-model="myModal" @ok="saveNews" effect="fade/zoom" ok-text="Save Changes" cancel-text="Cancel">
        <div slot="modal-header" class="modal-header">
          <h5 class="modal-title"><i class="fa fa-plus"></i> Add New Item</h5>
        </div>
        <div class="col-sm-12">
          <div class="card">
            <div class="card-block">
              <form action="" method="post" enctype="multipart/form-data" class="form-horizontal">
                <div class="form-group">
                  <label for="title">Title</label>
                  <input type="text" class="form-control" id="title" placeholder="Enter Title For News" v-model="formData.title">
                </div>
                <div class="form-group">
                  <label for="newsBody">News Body</label>
                  <textarea id="newsBody" name="textarea-input" rows="9" class="form-control" placeholder="Content.." v-model="formData.body"></textarea>
                </div>
                <div class="form-group">
                  <label for="weblink">Web Link</label>
                  <input type="text" class="form-control" id="weblink" placeholder="Enter web link" v-model="formData.link">
                </div>
                <div class="row">
                  <div class="form-group col-sm-6">
                    <label>Start Date</label><br>
                    <datepicker class="formcontrol" id="startDate" :value="element" format="MM/dd/yyyy" :clear-button="clearButtonsVisible" v-model='formData.startDate'></datepicker>
                  </div>
                  <div class="form-group col-sm-6">
                    <label>End Date</label><br>
                    <datepicker class="formcontrol" id="endDate" :value="element" format="MM/dd/yyyy" :clear-button="clearButtonsVisible" v-model='formData.endDate'></datepicker>
                  </div>
                </div><!--/.row-->
              </form>
            </div>
          </div>
        </div><!--/.col-->
      </b-modal>
    </div><!--wrapper-->
</template>

<script>
import { tokenMixin } from '@/mixins/tokenMixin'
import datepicker from 'vue-bootstrap-datetimepicker';
import modal from 'bootstrap-vue'

export default {
  name: 'AdminNews',
  mixins: [tokenMixin],
  components: {
    //modal,
    datepicker
  },
  data () {
    return {
      newsList: [],
      myModal: false,
      element: '',
      clearButtonsVisible: true,
      formData: {
        title: '',
        body: '',
        link: '',
        startDate: '',
        endDate: ''
      }
    }
  },
  methods: {
    addNews (e) {
      e.preventDefault();
      this.myModal = true;
      console.log('Add News');
    },
    saveNews () {
      this.myModal = false;
      this.axios.put(process.env.VUE_APP_API_BASE + 'news/addnews', this.formData, this.buildTokenHeader())
        .then(function (response) {
          console.log(response);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    formatDate (dateIn) {
      if (dateIn === null || dateIn === '0001-01-01T00:00:00')
      {
        return ''
      }
      else {
        var dateOut = new Date(dateIn);
        return dateOut.toLocaleDateString();
      }
    },
    deleteNews (index, undelete) {
      console.log('delete' + index);
      console.log(this.newsList[index].title);
      this.newsList[index].isDeleted = true;
    }
  },
  mounted: function () {
    //from the mixin
    if (this.checkForToken())
    {
      this.axios.get(process.env.VUE_APP_API_BASE + 'news/admin/getall', this.buildTokenHeader).then(response => {
        return response
      })
      .then(res => {
        if (res.status === 200)
        {
          this.newsList = res.data;
        }
      })
      .catch(error => {
        console.log(error.response)
      });
    }
  }
}
</script>
